export default __webpack_public_path__ + "static/media/Hack4OpenGLAM.b5464470.png";